import React, { useEffect, useRef, useState } from "react";
import { currentTenant, logo, prefix1 } from "../Common/Credentials";
import UploadFilesService from "../Common/upload/UploadFilesService";
import MasterService from "../Masters/MasterService";
import FileServices from "../Common/upload/FileServices";
import { Building, Trash2, UploadCloud, UploadIcon } from "lucide-react";
import { toast } from "../NewUI/NewComponents/toastService";

const LogoUpdate = () => {
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [previewImage, setPreviewImage] = useState(logo);
  const [imageloader, setImageloader] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [file, setFile] = useState("");
  const [fileInfos, setFileInfos] = useState([]);

  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const [logoDimensions, setLogoDimensions] = useState({ width: 60, height: 60 });

  useEffect(() => {
    if (!previewImage) return;
    let i = new Image();
    i.src = previewImage;

    setTimeout(() => {
      setLogoDimensions(getLogoDimensions(i.naturalWidth, i.naturalHeight));
    }, 100);
  }, [previewImage])

  const getLogoDimensions = (imgWidth, imgHeight, logoExists = true) => {
    if (!logoExists) {
      return { width: 60, height: 60 };
    }

    const aspectRatio = imgWidth / imgHeight;

    let width;
    let height;

    if (aspectRatio > 2) {
      // Very wide landscape logo
      height = 45;
      width = height * aspectRatio;
    } else if (aspectRatio >= 1.2 && aspectRatio < 2) {
      // Normal landscape logo
      width = 60;
      height = width / aspectRatio;
    } else if (aspectRatio >= 0.7 && aspectRatio <= 1.2) {
      // Portrait / Square logo
      height = 60;
      width = height * aspectRatio;
    } else {
      // Tall portrait logo
      width = 45;
      height = width / aspectRatio;
    }

    // Ensure height never exceeds 60px
    if (height > 60) {
      const scale = 60 / height;
      height = 60;
      width = width * scale;
    }

    return {
      width: Number(width.toFixed(2)),
      height: Number(height.toFixed(2))
    };
  };

  const processLogoFile = (file) => {
    if (!file) return;

    const validTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
    ];

    if (!validTypes.includes(file.type)) {
      setMessage("Only PNG, JPG, JPEG and SVG files are allowed");
      setIsError(true);
      return;
    }

    const sizeMB = file.size / (1024 * 1024);

    if (sizeMB > 2) {
      setMessage("Logo size must be less than 2MB");
      setIsError(true);
      return;
    }

    setSelectedFiles([file]);
    setPreviewImage(URL.createObjectURL(file));
    setMessage("");
    setIsError(false);
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      processLogoFile(files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const files = e.dataTransfer.files;

    if (files && files.length > 0) {
      processLogoFile(files[0]);
    }
  };

  const upload = async () => {
    try {
      if (!selectedFiles || selectedFiles.length === 0) return;

      const currentFile = selectedFiles[0];

      const year = new Date().getFullYear();
      const day = new Date().getDate();
      const mn = new Date().getMonth() + 1;

      // Without moment.js
      const curmonth = new Date(0, mn - 1).toLocaleString("default", {
        month: "long",
      });

      setProgress(100);
      setCurrentFile(currentFile);

      await UploadFilesService.logoupload(
        currentFile,
        year,
        curmonth,
        "logo",
        prefix1,
        day,
        (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
          setFile(currentFile);

        }
      )

      const response = await FileServices.getFiles1(currentFile.name);

      const filedata = response.data.map((e) => e.name);

      const path = `${prefix1}/logo/${prefix1}/${year}/${curmonth}/${day}`;

      await MasterService.updateTenantLogo({
        id: currentTenant,
        logofile: filedata.toLocaleString(),
        logopath: path,
      }).then(() => {
        toast("Logo uploaded successfully!, need to relogin to see the changes", "success");
      }).catch((err) => {
        toast(err?.response || "Failed to upload logo!", "error");
      })

      setFileInfos(response.data);
      setFile(filedata.toLocaleString());

      setMessage("Logo uploaded successfully!");
      setIsError(false);

      // Clear selected file after upload
      setSelectedFiles(undefined);
    } catch (err) {
      console.log(err);

      setProgress(0);
      setMessage("Could not upload the file!");
      setCurrentFile(undefined);
      setIsError(true);
    }
  };

  // Re-upload
  const handleReupload = (e) => {
    if (e) e.stopPropagation();

    setSelectedFiles(null);
    setPreviewImage(null);
    setMessage("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    // <div className="col-md-12">
    //   <label className="UI-label mt-3">
    //     Logo Upload :&nbsp;&nbsp;
    //     {selectedFiles && selectedFiles.length > 0
    //       ? selectedFiles[0].name
    //       : ""}
    //   </label>

    //   {!selectedFiles ? (
    //     <>
    //       <div
    //         onClick={() => document.getElementById("fileInput").click()}
    //         className="tw-border-2 tw-border-dashed tw-border-gray-300 tw-p-6 tw-text-center tw-rounded-lg hover:tw-bg-gray-50 tw-cursor-pointer"
    //       >
    //         <p className="tw-text-gray-500">Click to upload</p>

    //         <input
    //           id="fileInput"
    //           type="file"
    //           accept="image/*"
    //           onChange={selectFile}
    //           className="tw-hidden"
    //         />
    //       </div>
    //     </>
    //   ) : (
    //     <>
    //       <button
    //         type="button"
    //         className="UI-btn UI-btn-primary mx-1"
    //         disabled={!selectedFiles}
    //         onClick={upload}
    //       >
    //         Upload
    //       </button>

    //       <button
    //         type="button"
    //         className="UI-btn UI-btn-outline"
    //         onClick={handleReupload}
    //       >
    //         Reupload
    //       </button>
    //     </>
    //   )}

    //   <p id="fileInfo" className="text-red ml-4"></p>

    //   <div className="col-md-3" />

    //   {previewImage && (
    //     <div className="tw-mt-4">
    //       {imageloader ? (
    //         <div className="tw-text-gray-500">Uploading...</div>
    //       ) : (
    //         <img
    //           alt="Logo Preview"
    //           height="150"
    //           className="finanzzlogo tw-rounded-md tw-border"
    //           src={previewImage}
    //         />
    //       )}
    //     </div>
    //   )}

    //   <div className="col-md-9 tw-mt-3">
    //     <span
    //       className={`${
    //         isError ? "tw-text-red-500" : "tw-text-green-600"
    //       }`}
    //     >
    //       {message}
    //     </span>
    //   </div>
    // </div>


    <div
      id="setting-logo-upload"
      className="tw-py-5 tw-flex tw-flex-col md:tw-flex-row tw-items-stretch md:tw-items-center tw-justify-between tw-gap-4"
    >
      {/* Left Side */}
      <div className="tw-flex tw-items-center tw-gap-3.5 tw-shrink-0">
        <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-indigo-50 tw-text-indigo-600 tw-flex tw-items-center tw-justify-center">
          <Building size={18} />
        </div>

        <div>
          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">
            Company Logo
          </span>

          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium">
            Upload your brand identity
          </span>
        </div>
      </div>

      {/* Upload Area */}
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
        className={`tw-flex-1 tw-max-w-md tw-border-2 tw-border-dashed tw-rounded-2xl tw-p-4 tw-transition-all tw-cursor-pointer
      ${selectedFiles
            ? "tw-border-emerald-300 tw-bg-emerald-50/30"
            : isDragging
              ? "tw-border-indigo-500 tw-bg-indigo-50"
              : "tw-border-slate-200 tw-bg-slate-50 hover:tw-bg-slate-100"
          }
    `}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".png,.jpg,.jpeg,.svg"
          onChange={handleFileSelect}
          className="tw-hidden"
        />

        {selectedFiles ? (
          <div
            className="tw-flex tw-items-center tw-justify-between"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-3">
              <img
                src={previewImage}
                alt="logo"
                className="tw-object-contain tw-p-1"
                width={logoDimensions.width}
                height={logoDimensions.height}
              />

              <div>
                <div className="tw-text-xs tw-font-black tw-text-slate-800 tw-max-w-[170px] tw-truncate">
                  {selectedFiles[0]?.name}
                </div>

                <div className="tw-text-[10px] tw-text-slate-400 tw-font-bold">
                  {(selectedFiles[0]?.size / 1024).toFixed(2)} KB
                </div>
              </div>
            </div>

            <div className="tw-flex tw-items-center tw-gap-2">
              <button
                title="upload"
                onClick={upload}
                className="tw-p-2 tw-rounded-xl tw-text-slate-400 hover:tw-bg-gradient-to-r hover:tw-from-blue-600 hover:tw-to-indigo-600 hover:tw-text-white tw-text-xs tw-font-bold hover:tw-shadow-lg"
              >
                <UploadIcon size={16} />
              </button>

              <button
                title="Reupload"
                onClick={handleReupload}
                className="tw-p-2 tw-text-slate-400 hover:tw-text-red-500 hover:tw-bg-slate-100 tw-rounded-xl"
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ) :
          previewImage ?
            <div
              className="tw-flex tw-items-center tw-justify-between"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="tw-flex tw-items-center tw-gap-3">
                <img
                  src={previewImage}
                  alt="logo"
                  className="tw-object-contain  tw-p-1"
                  width={logoDimensions.width}
                  height={logoDimensions.height}
                />
              </div>

              <div className="tw-flex tw-items-center tw-gap-2">
                <button
                  onClick={handleReupload}
                  className="tw-p-2 tw-text-slate-400 hover:tw-text-red-500 hover:tw-bg-slate-100 tw-rounded-xl"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
            : (
              <div className="tw-text-center tw-space-y-2">
                <UploadCloud
                  size={22}
                  className="tw-mx-auto tw-text-slate-400"
                />

                <div>
                  <p className="tw-text-xs tw-font-bold tw-text-slate-700">
                    Click or Drag & Drop
                  </p>

                  <p className="tw-text-[10px] tw-text-slate-400 tw-font-semibold">
                    PNG, JPG, SVG up to 2MB
                  </p>
                </div>
              </div>
            )}
        {progress > 0 && progress < 100 && (
          <div className="tw-mt-3 tw-max-w-md tw-ml-auto">
            <div className="tw-h-2 tw-bg-slate-100 tw-rounded-full">
              <div
                className="tw-h-2 tw-rounded-full tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600"
                style={{ width: `${progress}%` }}
              />
            </div>

            <p className="tw-text-[11px] tw-font-semibold tw-text-slate-500 tw-mt-1">
              Uploading... {progress}%
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoUpdate;